import {Typography} from '@mui/material';
import {PropsWithChildren, ReactNode} from 'react';
import {styled} from '@mui/material/styles';

import {useIsDownSm} from 'utils/hooks/useMediaQuery';

export type BlockProps = DataTestId & {label: ReactNode; helperText?: ReactNode};

const SBlock = styled('div')(({theme}) => ({
  display: 'grid',
  gap: theme.spacing(4),
}));

export function Block({label, helperText, children, dataTestId}: PropsWithChildren<BlockProps>) {
  const isDownSm = useIsDownSm();
  return (
    <SBlock data-testid={dataTestId}>
      <Typography variant={isDownSm ? 'subtitle2' : 'subtitle1'}>{label}</Typography>
      {children}
      {helperText && (
        <Typography variant='body3' color='text.secondary'>
          {helperText}
        </Typography>
      )}
    </SBlock>
  );
}
